/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Engagement_Bullet_WeeksInputs */

const en_marketing_engagement_bullet_weeks = /** @type {(inputs: Marketing_Engagement_Bullet_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weeks to production, not quarters`)
};

const es_marketing_engagement_bullet_weeks = /** @type {(inputs: Marketing_Engagement_Bullet_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semanas hasta producción, no trimestres`)
};

const fr_marketing_engagement_bullet_weeks = /** @type {(inputs: Marketing_Engagement_Bullet_WeeksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des semaines jusqu'à la production, pas des trimestres`)
};

/**
* | output |
* | --- |
* | "Weeks to production, not quarters" |
*
* @param {Marketing_Engagement_Bullet_WeeksInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_engagement_bullet_weeks = /** @type {((inputs?: Marketing_Engagement_Bullet_WeeksInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Engagement_Bullet_WeeksInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_engagement_bullet_weeks(inputs)
	if (locale === "es") return es_marketing_engagement_bullet_weeks(inputs)
	return fr_marketing_engagement_bullet_weeks(inputs)
});